import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../../_shared/domain/administrator-draft.validation';

const selectEditAdministrator = (state: RootState) => state.editAdministrator;

export const selectUser = (state: RootState) => selectEditAdministrator(state).user;
export const selectDraft = (state: RootState) => selectEditAdministrator(state).draft;
export const selectLoadStatus = (state: RootState) => selectEditAdministrator(state).loadStatus;
export const selectSaveStatus = (state: RootState) => selectEditAdministrator(state).saveStatus;
export const selectArchiveStatus = (state: RootState) =>
  selectEditAdministrator(state).archiveStatus;
export const selectError = (state: RootState) => selectEditAdministrator(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectEditAdministrator(state).validationErrors;

export const selectIsSaving = (state: RootState) =>
  selectEditAdministrator(state).saveStatus === 'saving';
export const selectIsArchiving = (state: RootState) =>
  selectEditAdministrator(state).archiveStatus === 'saving';
export const selectLoadFailed = (state: RootState) =>
  selectEditAdministrator(state).loadStatus === 'failed';

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);

/** Derived: why the LinkedIn URL is refused, if it is (#617). Memoised on the draft. */
export const selectLinkedInUrlError = createSelector(
  selectDraft,
  (draft) => validateDraft(draft).linkedinUrl,
);
